export class StatesGdpModel{
  constructor (
    public name: string,
    public gdp2ndQua2020: number,
    public gdpPerCapita: number,
    public region: string){}
}
